import { SecuredRestService } from 'shared';
import {
    IUserInfo,
    IUsersService,
    SUPER_ROLE,
    HR_SUPER_ROLE,
    INITIATOR_ROLE,
    EXTERNAL_ROLE, IProperty
} from "../users-service-types";

export class UsersService extends SecuredRestService implements IUsersService {
    loadUserInfo = (): Promise<IUserInfo> => {
        return this.get<IUserInfo>({
            url: 'user',
        }).then(res => {
            return {...res,
                isSuper: res.roles.includes(SUPER_ROLE),
                isHrSuper: res.roles.includes(HR_SUPER_ROLE),
                isInitiator: res.roles.includes(INITIATOR_ROLE),
                isExternal: res.roles.includes(EXTERNAL_ROLE),
            }
        });
    };

    loadProperties = (): Promise<IProperty[] | string> => {
        return this.get<IProperty[] | string>({
            url: 'properties',
        }).then(res => {
            return res;
        });
    };

    cacheDepartments = (): Promise<string> => {
        return this.get<string>({
            url: 'staff/person_groups',
        })
    };
}
